import PropTypes from 'prop-types';
import Clickable from '../../../UI/Clickable/Clickable';
import classes from './SidebarElement.module.css';

const SidebarElement = ({ label, onClick, index }) => (
  <Clickable onClick={onClick} className={classes.link}>
    <p className={classes.index}>{index}</p>
    <p className={classes.label}>{label}</p>
  </Clickable>
);

SidebarElement.propTypes = {
  label: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
export default SidebarElement;
